import instance from '@apis/instance';

class UserEventApi {
    static updateDau(projectId: string): Promise<never> {
        return instance.put('/v0/events/user/active', { projectId });
    }
}

export default UserEventApi;
